import React from 'react'
import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'
import Session from 'components/Session'
import { MediaQuery } from 'stylist'

const Menu = () => (
  <Session
    render={({ isAuthenticated }) => (
      <MediaQuery below="md">
        {matches =>
          matches ? (
            <MobileMenu isAuthenticated={isAuthenticated} />
          ) : (
            <DesktopMenu isAuthenticated={isAuthenticated} />
          )
        }
      </MediaQuery>
    )}
  />
)

export default Menu



// WEBPACK FOOTER //
// ./src/routes/components/Menu.js